import { Button } from "@mui/material";
import { GetApp as GetAppIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useCaseResultDownload } from "src/hooks/results";

interface Props {
  caseId: string | number;
}
export function DownloadCaseResultButton(props: Props) {
  const { data } = useCaseResultDownload(props.caseId);
  const { t } = useTranslation();

  return render();

  function render() {
    if (!data) return null;

    return (
      <Button
        variant="contained"
        color="primary"
        startIcon={<GetAppIcon />}
        fullWidth
        component="a"
        href={data.downloadUrl}
        download
      >
        {t("label.downloadOutput")}
      </Button>
    );
  }
}
